import { Category, Subcategory } from './category';
import { Company } from './company';
import { CostCenter } from './cost-center';
import { Money } from './money';
import type { Transaction } from './transaction';

export const TransactionAllocationResourceType = 'transaction-allocation';

export interface TransactionAllocation {
  id: string;
  amount: Money;
  createdAt?: string;
  transaction: Transaction;
  company?: Company;
  category?: Category;
  subcategory?: Subcategory;
  costCenter?: CostCenter;
}

export interface TransactionAllocationUpdatePayload {
  lid: string;
  category?: {
    id: Category['id'];
  } | null;
  subcategory?: {
    id: Subcategory['id'];
  } | null;
  costCenter?: {
    id: CostCenter['id'];
  } | null;
  amount: Money;
}
